export const MarketingCampaigns = Object.freeze({
  BlackFriday: {
    name: 'BlackFriday',
    color: '#00A351',
    s3Path: '/images/frontend/try-now/lp/bf'
  },
  TwoForOne: {
    name: 'TwoForOne',
    color: '#00A351',
    s3Path: '/images/design/m4r5/try-now'
  }
})

export const ActiveCampaign = MarketingCampaigns.TwoForOne

export const CampaignStrategies = Object.freeze({
  extraOrder: 'extra_order'
})
